import React, { useState } from "react";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { NextArrow, PrevArrow } from "../Shared";
import { PhotoSwipe } from "react-photoswipe";
import ModalVideo from 'react-modal-video';
import "react-lazy-load-image-component/src/effects/blur.css";

const galleryHeight = 400;

export default function ImageBoard({ images = [], video }) {

    const [showImageCarousel, setShowImageCarousel] = useState();
    const [currentImageIndex, setCurrentImageIndex] = useState();
    const [isVideoOpen, setVideoOpen] = useState(false);

    function getMainBoardItemStyle() {
        let array = Array(5).fill().map(() => ({}));
        // console.log(array);

        switch(images.length){
            case 1: 
                array[0] = { gridColumn: "1 / 5"}
                break;
            case 2:
                array[0] = {  gridColumn: "1 / 3"}
                array[1] = {  gridRow: "1 / 3"}
                break;
            case 3:
                array[0] = {  gridColumn: "1 / span 3"}                
                break;
            case 4: 
                array[3] = { gridColumn: "3 / span 2"}
                break;

        }

        return array;
    }

    const styleArray = getMainBoardItemStyle();

    function getProductImages() {
        return images.map((image) => ({
            src: image.large,
            w: 1600,
            h: 1000,
        }));
    }

    function showProductImage(index) {
        setCurrentImageIndex(index);
        setShowImageCarousel(true);
    }

    const VideoPlayButton = () => (
        <div className="flex-center position-absolute w-100 z-2">
            <div className="text-center">
                <button 
                    className="btn btn-flat js-modal-btn cursor-pointer" 
                    onClick={() => setVideoOpen(true)}>
                    <span className="font-larger text-shadow-1 white-text">
                        <i className="far fa-play-circle fa-5x"></i>
                    </span>
                </button>
            </div>
        </div>
    );

    return (
        <div>
            <div className="container">
                {!_.isEmpty(video) && 
                    <ModalVideo 
                        channel={video.channel} 
                        isOpen={isVideoOpen} 
                        videoId={video.id} 
                        onClose={() => setVideoOpen(false)} 
                    />
                }
                <div
                    className="image-board position-relative"
                    style={{ height: galleryHeight }}
                >
                    <div className="main-board-item position-relative" style={styleArray[0]}>
                        {!_.isEmpty(video) && ( 
                            <VideoPlayButton />

                        )}
                        <LazyLoadImage
                            alt="image"
                            height="100%"
                            width="100%"
                            placeholderSrc={images[0].small}
                            src={images[0].large}
                            className="board-image"
                            effect="blur"                            
                            onClick={() => showProductImage(0)}
                        />                    
                    </div>
                    {images.slice(1, 5).map((image, index) => (
                        <div
                            className="image-board-item"
                            style={{ ...styleArray[index + 1] }}
                            key={index}
                        >
                            <LazyLoadImage
                                alt="image"
                                height="100%"
                                width="100%"
                                placeholderSrc={image.small}
                                className="board-image"
                                src={image.medium}
                                effect="blur"
                                onClick={() => showProductImage(index + 1)}
                            />
                        </div>
                    ))}
                    {images.length > 5 && 
                        <button
                            className="btn position-absolute all-images-button text-white small"
                            data-toggle="modal" 
                            data-target="#galleryModal"
                        >{`${images.length - 5} more`}</button>
                    }           
                </div>
            </div>

            <div className="d-md-none">
                <Slider
                    {...{
                        dots: false,
                        className: "slick-carousel slick-no-padding mdb-lightbox",
                        speed: 500,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: 0,
                        initialSlide: 0,
                        prevArrow: <PrevArrow left="10px" />,
                        nextArrow: <NextArrow right="10px" />,
                        // responsive: [
                        //     {
                        //         breakpoint: 1024,
                        //         settings: {
                        //             slidesToShow: images.length >= 3 ? 2 : 2,
                        //             slidesToScroll: 1,
                        //             infinite: true,
                        //             dots: true
                        //         }
                        //     },
                        //     {
                        //         breakpoint: 600,
                        //         settings: {
                        //             slidesToShow: 2,
                        //             slidesToScroll: 1,
                        //             initialSlide: 0
                        //         }
                        //     },
                        //     {
                        //         breakpoint: 480,
                        //         settings: {
                        //             arrows: false,
                        //             centerMode: true,
                        //             centerPadding: '20px',
                        //             slidesToShow: 1,
                        //             slidesToScroll: 1
                        //         }
                        //     }
                        // ]
                    }}
                >
                    {!_.isEmpty(video) && ( 
                        <div className="position-relative">
                            <img
                                src={images[0].medium}
                                className="img-fluid slick-image cursor-pointer"
                            />

                            <div className="flex-center position-absolute w-100 z-2" style={{top: 0}}>
                                <div className="text-center">
                                    <button 
                                        className="btn btn-flat js-modal-btn cursor-pointer" 
                                        onClick={() => setVideoOpen(true)}>
                                        <span className="font-larger text-shadow-1 white-text">
                                            <i className="far fa-play-circle fa-5x"></i>
                                        </span>
                                    </button>
                                </div>                            
                            </div>
                        </div>

                    )}

                    {
                        
                        (!_.isEmpty(video) ? images.slice(1, images.length) : images).map((image, index) => {
                        return (
                            <div
                                key={index}
                                onClick={() => showProductImage(!_.isEmpty(video) ? index + 1 : index)}
                            >
                                <img
                                    src={image.medium}
                                    className="img-fluid slick-image cursor-pointer"
                                />
                            </div>
                        );
                    })}
                </Slider>
            </div>

            <PhotoSwipe
                isOpen={showImageCarousel}
                items={getProductImages()}
                onClose={() => setShowImageCarousel(false)}
                options={{
                    index: currentImageIndex,
                    history: false,
                    closeOnScroll: false,
                    shareEl: false,
                    zoomEl: false,
                }}
            />

            <div className="modal fade" id="galleryModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn btn-close" data-dismiss="modal" aria-label="Close">
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div className="d-flex flex-wrap">
                                {images.map((image, index) => (
                                    <LazyLoadImage
                                        key={index}
                                        alt="image"                                        
                                        className="board-image m-2"
                                        placeholderSrc="/images/placeholder-500x500.png"
                                        src={image.small}
                                        height="100px"
                                        width="100px"
                                        onClick={() => showProductImage(index)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./resources/js/components/ImageBoard/index.js